<template>
  <div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { StepRegistration } from './Step.vue'

interface Props {
  progress?: number
}

const props = withDefaults(defineProps<Props>(), {
  progress: 1,
})

const registeredSteps = ref<StepRegistration[]>([])

// Provide register/unregister functions for child Step components
provide('steps-register', (step: StepRegistration) => {
  registeredSteps.value.push(step)
})

provide('steps-unregister', (step: StepRegistration) => {
  const index = registeredSteps.value.indexOf(step)
  if (index > -1) {
    registeredSteps.value.splice(index, 1)
  }
})

watch(() => props.progress, (value) => {
  setState(value)
})

onMounted(() => {
  nextTick(() => {
    setState(props.progress)
  })
})

function setState(progress: number) {
  for (let index = 0; index < registeredSteps.value.length; index++) {
    const step = registeredSteps.value[index]
    const stepIndex = index + 1

    if (stepIndex === progress) {
      step.state = 'active'
    } else if (stepIndex < progress) {
      step.state = 'complete'
    } else {
      step.state = 'disabled'
    }
  }
}
</script>
